import { render, staticRenderFns } from "./MSTeamsPresentationsList.vue?vue&type=template&id=9d791eb4&"
import script from "./MSTeamsPresentationsList.vue?vue&type=script&lang=js&"
export * from "./MSTeamsPresentationsList.vue?vue&type=script&lang=js&"
import style0 from "./MSTeamsPresentationsList.vue?vue&type=style&index=0&lang=scss&scroped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports